import { createFileRoute } from '@tanstack/react-router';

import { FeatureFlagDetailView } from '../../../features/feature-flags/feature-flag-detail-view';

export const Route = createFileRoute('/admin/feature-flags/$flagKey')({
  staticData: {
    breadcrumb: (match) => (match.params as { flagKey: string }).flagKey,
  },
  component: FeatureFlagDetailView,
});
